import React, { useEffect, useState } from "react";
import api from "../../services/api";

const StatCard = ({ label, value, color, bg }) => (
  <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "1rem" }}>
    <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>{label}</div>
    <div style={{ fontSize: "22px", fontWeight: "500", color: color || "#111827" }}>{value}</div>
  </div>
);

const DashboardAdmin = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showReinit, setShowReinit] = useState(false);
  const [reinitLoading, setReinitLoading] = useState(false);
  const [reinitMsg, setReinitMsg] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/commercials/dashboard/admin");
        setData(res.data);
      } catch (err) {
        setError("Impossible de charger le dashboard");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleReinit = async () => {
    setReinitLoading(true);
    setReinitMsg("");
    try {
      await api.post("/commercials/reinitialiser");
      setReinitMsg("✅ Réinitialisation effectuée avec succès !");
      setTimeout(() => { setShowReinit(false); setReinitMsg(""); }, 2000);
    } catch (err) {
      setReinitMsg("❌ " + (err.response?.data?.error || "Erreur lors de la réinitialisation"));
    } finally {
      setReinitLoading(false);
    }
  };

  const today = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh" }}>
      <div style={{ width: "36px", height: "36px", border: "3px solid #f3f4f6", borderTop: "3px solid #7c3aed", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
    </div>
  );

  if (error) return <div style={{ padding: "2rem", textAlign: "center", color: "#dc2626" }}>{error}</div>;

  const { performance_par_commercial: commerciaux, performance_par_superviseur: superviseurs, repartition_scores } = data;

  return (
    <div style={{ padding: "1.5rem" }}>
      {/* Modal confirmation réinitialisation */}
      {showReinit && (
        <div onClick={() => setShowReinit(false)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "420px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "0.75rem" }}>
              <div style={{ width: "36px", height: "36px", borderRadius: "50%", backgroundColor: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <svg width="18" height="18" fill="none" stroke="#dc2626" strokeWidth="2" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              </div>
              <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0, color: "#dc2626" }}>Réinitialisation fin de mois</h3>
            </div>
            <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "0.75rem", lineHeight: 1.6 }}>
              Cette action va remettre à zéro les <strong>soldes, coupons vendus et statistiques</strong> de tous les commerciaux.
            </p>
            <div style={{ padding: "0.75rem", backgroundColor: "#fef2f2", borderRadius: "8px", marginBottom: "1.25rem", fontSize: "13px", color: "#dc2626", fontWeight: "500" }}>
              ⚠️ Cette action est <strong>irréversible</strong>. Assurez-vous d'avoir calculé les salaires avant de continuer.
            </div>
            {reinitMsg && (
              <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: reinitMsg.startsWith("✅") ? "#f0fdf4" : "#fef2f2", borderRadius: "8px", fontSize: "13px", color: reinitMsg.startsWith("✅") ? "#16a34a" : "#dc2626" }}>
                {reinitMsg}
              </div>
            )}
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={() => setShowReinit(false)} style={{ flex: 1, padding: "0.75rem", border: "1px solid #e5e7eb", borderRadius: "9999px", backgroundColor: "white", color: "#6b7280", fontSize: "13px", cursor: "pointer" }}>
                Annuler
              </button>
              <button onClick={handleReinit} disabled={reinitLoading} style={{ flex: 1, padding: "0.75rem", backgroundColor: "#dc2626", color: "white", fontWeight: "500", fontSize: "13px", borderRadius: "9999px", border: "none", cursor: reinitLoading ? "not-allowed" : "pointer", opacity: reinitLoading ? 0.7 : 1 }}>
                {reinitLoading ? "En cours..." : "Confirmer la réinitialisation"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{ marginBottom: "1.5rem" }}>
        <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Dashboard Administrateur</h1>
        <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>{today}</p>
      </div>

      {/* Stats globales portefeuille */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem", marginBottom: "1.25rem" }}>
        <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>Portefeuille global</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "12px" }}>
          <StatCard label="Score moyen" value={Number(data.score_moyen_global).toFixed(1)} color="#7c3aed" />
          <StatCard label="Taux remb." value={`${data.taux_remboursement}%`} color="#16a34a" />
          <StatCard label="Total crédits" value={data.total_credits} />
          <StatCard label="Remboursés" value={data.total_credits_rembourses} color="#16a34a" />
          <StatCard label="Non remb." value={data.total_credits_non_rembourses} color="#dc2626" />
          <StatCard label="En cours" value={data.credits_en_cours} color="#185FA5" />
          <StatCard label="En retard" value={data.credits_en_retard} color="#ea580c" />
          <StatCard label="Clients bloqués" value={data.clients_bloques} color="#dc2626" />
          <StatCard label="À risque" value={data.clients_a_risque} color="#ea580c" />
        </div>
      </div>

      {/* Répartition scores */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem", marginBottom: "1.25rem" }}>
        <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>Répartition des scores clients</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "12px" }}>
          <StatCard label="Très fiables" value={repartition_scores?.tres_fiable || 0} color="#16a34a" />
          <StatCard label="Fiables" value={repartition_scores?.fiable || 0} color="#ca8a04" />
          <StatCard label="À risque" value={repartition_scores?.a_risque || 0} color="#ea580c" />
          <StatCard label="Bloqués" value={repartition_scores?.bloque || 0} color="#dc2626" />
        </div>
      </div>

      {/* Performance superviseurs */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden", marginBottom: "1.25rem" }}>
        <div style={{ padding: "1rem 1.25rem", borderBottom: "0.5px solid #e5e7eb" }}>
          <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>Superviseurs ({data.nb_superviseurs})</div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#f9fafb" }}>
                {["Superviseur", "Commerciaux", "Clients", "Caisse fixe", "Solde début", "Sorties", "Entrées", "Solde actuel", "Coupons"].map(h => (
                  <th key={h} style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "11px", color: "#6b7280", fontWeight: "500", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {superviseurs?.map((sup, i) => (
                <tr key={sup.id} style={{ borderTop: "0.5px solid #f3f4f6" }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f9fafb"}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                  <td style={{ padding: "0.75rem 1rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ width: "30px", height: "30px", borderRadius: "50%", backgroundColor: "#f3e8ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "500", color: "#7c3aed" }}>
                        {sup.nom?.charAt(0)}{sup.prenom?.charAt(0)}
                      </div>
                      <div>
                        <div style={{ fontWeight: "500", color: "#111827" }}>{sup.prenom} {sup.nom}</div>
                        <span style={{ fontSize: "10px", backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "1px 6px", borderRadius: "4px" }}>{sup.produit_nom || "Cash24"}</span>
                        {!sup.actif && <span style={{ fontSize: "10px", color: "#9ca3af", marginLeft: "4px" }}>Archivé</span>}
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "0.75rem 1rem" }}>{sup.nb_commerciaux}</td>
                  <td style={{ padding: "0.75rem 1rem" }}>{sup.nb_clients_total}</td>
                  <td style={{ padding: "0.75rem 1rem", whiteSpace: "nowrap" }}>{Number(sup.caisse_fixe).toLocaleString("fr-FR")} F</td>
                  <td style={{ padding: "0.75rem 1rem", whiteSpace: "nowrap" }}>{Number(sup.solde_debut_journee).toLocaleString("fr-FR")} F</td>
                  <td style={{ padding: "0.75rem 1rem", color: "#dc2626", whiteSpace: "nowrap" }}>{Number(sup.sorties_credits).toLocaleString("fr-FR")} F</td>
                  <td style={{ padding: "0.75rem 1rem", color: "#16a34a", whiteSpace: "nowrap" }}>{Number(sup.entrees_credits).toLocaleString("fr-FR")} F</td>
                  <td style={{ padding: "0.75rem 1rem", fontWeight: "500", whiteSpace: "nowrap" }}>{Number(sup.solde_actuel).toLocaleString("fr-FR")} F</td>
                  <td style={{ padding: "0.75rem 1rem" }}>
                    <span style={{ backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "2px 8px", borderRadius: "6px", fontWeight: "500" }}>{sup.total_coupons_vendus}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Performance commerciaux */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden", marginBottom: "1.25rem" }}>
        <div style={{ padding: "1rem 1.25rem", borderBottom: "0.5px solid #e5e7eb" }}>
          <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>Commerciaux ({data.nb_commerciaux})</div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#f9fafb" }}>
                {["Commercial", "Clients", "Crédits", "Coupons", "Solde", "Remb. mois", "Non remb.", "Dette", "Pénalités", "Salaire net"].map(h => (
                  <th key={h} style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "11px", color: "#6b7280", fontWeight: "500", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {commerciaux?.map((com, i) => (
                <tr key={com.id} style={{ borderTop: "0.5px solid #f3f4f6" }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f9fafb"}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                  <td style={{ padding: "0.75rem 1rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ width: "30px", height: "30px", borderRadius: "50%", backgroundColor: "#E6F1FB", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "500", color: "#185FA5" }}>
                        {com.nom?.charAt(0)}{com.prenom?.charAt(0)}
                      </div>
                      <div>
                        <div style={{ fontWeight: "500", color: "#111827" }}>{com.prenom} {com.nom}</div>
                        <span style={{ fontSize: "10px", backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "1px 6px", borderRadius: "4px" }}>{com.produit_nom || "Cash24"}</span>
                        {!com.actif && <span style={{ fontSize: "10px", color: "#9ca3af", marginLeft: "4px" }}>Archivé</span>}
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "0.75rem 1rem" }}>{com.nb_clients}</td>
                  <td style={{ padding: "0.75rem 1rem" }}>{com.nombre_credits_octroyes}</td>
                  <td style={{ padding: "0.75rem 1rem" }}>
                    <span style={{ backgroundColor: "#E6F1FB", color: "#185FA5", padding: "2px 8px", borderRadius: "6px", fontWeight: "500" }}>{com.nombre_coupons_vendus}</span>
                  </td>
                  <td style={{ padding: "0.75rem 1rem", whiteSpace: "nowrap" }}>{Number(com.solde).toLocaleString("fr-FR")} F</td>
                  <td style={{ padding: "0.75rem 1rem", color: "#16a34a" }}>{com.credits_rembourses_mois}</td>
                  <td style={{ padding: "0.75rem 1rem", color: com.credits_non_rembourses > 0 ? "#dc2626" : "#9ca3af" }}>{com.credits_non_rembourses}</td>
                  <td style={{ padding: "0.75rem 1rem", color: com.dette_totale > 0 ? "#ea580c" : "#9ca3af", whiteSpace: "nowrap" }}>
                    {com.dette_totale > 0 ? `${Number(com.dette_totale).toLocaleString("fr-FR")} F` : "—"}
                  </td>
                  <td style={{ padding: "0.75rem 1rem", color: com.penalites_recuperees > 0 ? "#16a34a" : "#9ca3af", whiteSpace: "nowrap" }}>
                    {com.penalites_recuperees > 0 ? `${Number(com.penalites_recuperees).toLocaleString("fr-FR")} F` : "—"}
                  </td>
                  <td style={{ padding: "0.75rem 1rem", fontWeight: "500", color: "#7c3aed", whiteSpace: "nowrap" }}>
                    {Number(com.salaire_net_estime).toLocaleString("fr-FR")} F
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Zone réinitialisation fin de mois */}
      <div style={{ border: "1px solid #fecaca", borderRadius: "16px", padding: "1.25rem", backgroundColor: "#fff5f5" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" }}>
          <div>
            <div style={{ fontSize: "14px", fontWeight: "500", color: "#dc2626", marginBottom: "4px" }}>
              ⚠️ Réinitialisation fin de mois
            </div>
            <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>
              Remet à zéro les soldes, coupons et statistiques de tous les commerciaux. Action irréversible.
            </p>
          </div>
          <button onClick={() => setShowReinit(true)} style={{ padding: "0.6rem 1.5rem", backgroundColor: "white", color: "#dc2626", border: "1.5px solid #dc2626", borderRadius: "9999px", fontSize: "13px", fontWeight: "500", cursor: "pointer", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "6px" }}>
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
            Réinitialiser
          </button>
        </div>
      </div>

    </div>
  );
};

export default DashboardAdmin;